import { Box, Tag, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import CheckBox from 'modules/core/components/Inputs/CheckBox'

import VerbsColumn from 'modules/permissions/components/VerbsColumn'
import type { ToggleablePermission } from 'modules/permissions/pages/settings/PermissionGroupPage/List/Item/types'

interface Props {
  permissions: ToggleablePermission[]
  disabled: boolean
}

const ContextlessPermissionsList = ({ permissions, disabled }: Props) => {
  const half = Math.ceil(permissions.length / 2)

  const sortedPermissions = [...permissions].sort((a, b) => a.verbLabel.localeCompare(b.verbLabel))
  const firstHalf = sortedPermissions.slice(0, half)
  const secondHalf = sortedPermissions.slice(half)

  return (
    <Box flexDirection="row" width="full" gap="s32">
      <Column permissions={firstHalf} disabled={disabled} />
      {secondHalf.length > 0 && <Column permissions={secondHalf} disabled={disabled} />}
    </Box>
  )
}

interface ColumnProps {
  permissions: ToggleablePermission[]
  disabled: boolean
}

const Column = ({ permissions, disabled }: ColumnProps) => {
  return (
    <VerbsColumn>
      {permissions.map((permission) => (
        <ListItem key={permission.id} permission={permission} disabled={disabled} />
      ))}
    </VerbsColumn>
  )
}

interface ListItemProps {
  permission: ToggleablePermission
  disabled: boolean
}

const ListItem = ({ permission, disabled }: ListItemProps) => {
  return (
    <Box flexDirection="row" alignItems="flexStart" gap="s32">
      <Box alignItems="flexStart" width="full" flexWrap="noWrap" overflowX="hidden" gap="s4">
        <Text.Normal weight="semibold" size="200" ellipsis>
          {permission.verbLabel}
        </Text.Normal>
        {permission.verbDescription && (
          <Text.Normal color="grey700" size="200">
            {permission.verbDescription}
          </Text.Normal>
        )}
        {permission.resourceTags && permission.resourceTags.length > 0 && (
          <Box paddingTop="s4" gap="s4">
            {permission.resourceTags.map((tag) => (
              <Tag key={tag.id} inline type="neutral" size="small" ellipsis>
                {tag.label}
              </Tag>
            ))}
          </Box>
        )}
      </Box>
      <Box alignItems="center" paddingTop="s2" width="fit-content">
        <CheckBox disabled={disabled} onClick={permission.toggle} checked={permission.toggled} />
      </Box>
    </Box>
  )
}

export default observer(ContextlessPermissionsList)
